export default __webpack_public_path__ + "static/media/double-paddle-svgrepo-com.862af4e2.svg";